import { Calendar } from "lucide-react";
import { useRenewalForecast } from "../../hooks/use-api";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export function CertOverview(): React.ReactElement {
  const { data, isLoading } = useRenewalForecast();
  const forecast = data?.forecast ?? [];

  return (
    <Card data-testid="cert-overview-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold flex items-center gap-1.5">
          <Calendar className="h-3.5 w-3.5 text-muted-foreground" />
          Upcoming Renewals
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2" data-testid="cert-overview-loading">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ) : forecast.length === 0 ? (
          <p className="text-xs text-muted-foreground py-2 text-center" data-testid="cert-overview-empty">
            No renewals in the next 6 months.
          </p>
        ) : (
          <div className="space-y-1">
            {forecast.map((m, i) => (
              <div key={m.label} className="flex items-center justify-between text-sm">
                <span className={i === 0 ? "font-medium" : "text-muted-foreground"}>{m.label}</span>
                <span
                  className={`tabular-nums ${m.count > 0 ? (i === 0 ? "font-semibold" : "font-medium") : "text-muted-foreground"}`}
                >
                  {m.count}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
